import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Modal from '../../../../ui/components/common/Modal';
import {roomPasswordErrorSelector} from '../../../../store/selectors/roomProtection.selector';
import PasswordInputWithError from '../../../../ui/components/common/PaswordInputWithError';
import {ProtectionType} from '../../../../incase-domain/presentationProtection';
import {IFetchRoomProtection} from '../../../../incase-domain/rooms/room.player';

export interface GuestCredentials {
    identification?: string;
    password?: string;
}

interface PasswordModalProps {
    isOpen: boolean;
    onConfirm: (cr: GuestCredentials) => void;
    protection: IFetchRoomProtection | undefined;
}

function GuestModal({isOpen, onConfirm, protection}: PasswordModalProps): JSX.Element {
    const {t} = useTranslation();
    const error = useSelector(roomPasswordErrorSelector);

    const [identification, setIdentification] = useState('');
    const [password, setPassword] = useState('');

    const protectionTypes = protection?.protectionTypes || [];

    const handleConfirm = (): void => {
        onConfirm({identification, password});
    };

    return (
        <Modal
            isOpen={isOpen}
            header={t('form.continueAsGuest')}
            onConfirm={handleConfirm}
            blockOverlayClose
            dataCy="password_modal"
            confirmDisabled={
                (protectionTypes.includes(ProtectionType.PASSWORD) && password.trim() === '') ||
                (protectionTypes.includes(ProtectionType.IDENTIFICATION) && identification.trim() === '')
            }
        >
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleConfirm();
                }}
            >
                {protectionTypes.includes(ProtectionType.PASSWORD) && (
                    <PasswordInputWithError value={password} error={error} setValue={setPassword} />
                )}

                {protectionTypes.includes(ProtectionType.IDENTIFICATION) && (
                    <div className="u-mt-2">
                        <label htmlFor="specific-identification">{protection?.identificationLabel || t('form.identificationLabel')}</label>
                        <input
                            type="text"
                            id="specific-identification"
                            className="e-input"
                            value={identification}
                            onChange={(e) => setIdentification(e.target.value.trim())}
                        />
                    </div>
                )}
            </form>
        </Modal>
    );
}

export default GuestModal;
